import {CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

import {IonicModule} from '@ionic/angular';

import {VeranstaltungLoeschenPage} from './veranstaltung-loeschen.page';
import {SopiScrollModule} from '../../../sopi/components/sopi-scroll/sopi-scroll.module';
import {SopiComponentsModule} from '../../shared/sopi-components/sopi-components.module';

const routes: Routes = [
    {
        path: '',
        component: VeranstaltungLoeschenPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        SopiComponentsModule.forRoot(),
        SopiScrollModule
    ],
    declarations: [VeranstaltungLoeschenPage],
    entryComponents: [VeranstaltungLoeschenPage],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class VeranstaltungLoeschenPageModule {
    public static forRoot(): ModuleWithProviders<VeranstaltungLoeschenPageModule> {
        return {
            ngModule: VeranstaltungLoeschenPageModule,
            providers: []
        };
    }
}
